<template>
  <div class="loading" v-if="isShow">
      <div class="modal">
        <div class="img-box">
            <img src="../../assets/images/loading2.png" alt="">
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: "loading",
  props: {
      isShow: {
          type: Boolean,
          default: false
      }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.loading {
  position: fixed;
  top: 0;
  z-index: 200;
  width: 100%;
  height: 100%;
  .modal {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    .img-box {
      position: absolute;
      top: 50%;
      left: 50%;
      margin: -150px -48px;
      animation: imgrotate 2s linear infinite;
    }
  }
}
@keyframes imgrotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes imarotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/loading/loading.vue